<template>
<div>
  <div class="title-h4 title-bar">이벤트/알람 목록</div>
  <el-row class="title-bar responsive-btn" type="flex" justify="space-between">
    <div>
      <el-select v-show="managetypeId=='FMS'" v-model="managetypeKey" style="width:120px;" class="mr-r4">
        <el-option v-for="item in managetypeKeyList" :key="item.managetypeKey" :label="item.label" :value="item.managetypeKey"></el-option>
      </el-select>
      <span class="mr-r4">자원구분</span>
      <el-select class="mr-r4" style="width: 5.5vw;" v-model="rsctypeId">
        <el-option v-for="item in rsctypeList" :key="item.rsctypeId" :label="item.rsctypeName" :value="item.rsctypeId"></el-option>
      </el-select>
      <span class="mr-r4">자원</span>
      <el-select v-model="rsctypeRscKey" style="width:5.5vw;" class="mr-r4">
        <el-option v-for="item in rscList" :key="`${item.rsctypeId}.${item.rscId}`" :label="item.rscName" :value="`${item.rsctypeId}.${item.rscId}`"></el-option>
      </el-select>
      <span class="mr-r4" v-show="managetypeId === 'E2E'">
        <span>에이전트</span>
      <el-select v-model="agentObjId">
        <el-option v-for="agent in agentList" :key="agent.agentId" :label="agent.objName" :value="agent.objId" />
      </el-select>
      </span>
      <el-button v-if="hasAuth" size="mini" type="secondary" @click="deleteObjEventAlarmSettings" :disabled="checkedEventAlarmSettings.length == 0" class="mr-r4">정책복원</el-button>
      <el-button v-if="hasAuth" v-show="!isDynamicEvent" size="mini" type="primary" @click="saveObjEventAlarmSettingsToRule" :disabled="checkedEventAlarmSettings.length == 0 || !hasAuth">정책으로 저장</el-button>
      <el-tooltip v-if="hasAuth" v-show="isDynamicEvent" class="item" effect="dark" content="동적 이벤트는 정책으로 저장할 수 없습니다." placement="right">
        <span><el-button :disabled="true">정책으로 저장</el-button></span>
      </el-tooltip>
    </div>
    <div>
      <el-button class="mr-r4" type="primary" @click="saveEventAlarmSettingChanges" :disabled="!ruleChangeFlag">저장</el-button>
      <el-button class="mr-r4" @click="rejectEventAlarmSettingChanges" :disabled="!ruleChangeFlag">취소</el-button>
      <el-button class="mr-r4" size="small" @click="exportExcel"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
      <w-header-search-button size="mini" @click="toggleShowSearchTool"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper v-loading="ruleLoading" :style="tableHeightStyle" :fit-height="tableFitHeight" :element-loading-text="ruleLoadingText" ref="eventAlarmRuleTable" :data="eventAlarmRuleTableData"
    highlight-current-row @row-dblclick="editEventAlarmSettingData" @selection-change="onSelectionChange" remote :total="ruleTotal" @condition-change="loadRuleData" :show-custom-header="true"
    :show-search-tool="showSearchTool" row-class-name="c-dblclick" :pagination="true" :columns="eventAlarmRuleTableColumn" :column-default="columnDefault">
    <template slot-scope="scope" slot="apply-slot">
      <el-switch v-if="scope.row.eventlevelId != 'NM'" v-model="scope.row.applyFlag" active-value="Y" inactive-value="N" :disabled="scope.row.eventlevelId === 'NM' || !hasAuth" @change="changeApplyFlag(scope.row)"></el-switch>
    </template>
    <template slot-scope="scope" slot="individual-slot">
      <span v-show="scope.row.individualFlag == 'Y'"><i class="fas fa-circle text-mini state-normal" /></span>
      <span v-show="scope.row.individualFlag == 'N'"> <i class="fas fa-circle text-mini" style="color:#bbb"/></span>
    </template>
    <template slot-scope="scope" slot="eventlevel-slot">
      <w-eventlevel-cell :eventlevel-id="scope.row.eventlevelId"/>
    </template>
    <template slot-scope="scope" slot="sms-slot">
      <el-switch v-model="scope.row.smsFlag" active-value="Y" inactive-value="N" @change="checkEventAlarmRuleChanges"></el-switch>
    </template>
    <template slot-scope="scope" slot="email-slot">
      <el-switch v-model="scope.row.emailFlag" active-value="Y" inactive-value="N" @change="checkEventAlarmRuleChanges"></el-switch>
    </template>
    <template slot-scope="scope" slot="script-slot">
      <i v-if="hasAuth" class="far fa-search-plus c-pointer" @click.stop="showEventAlarmScriptSetting(scope.row)"/>
      <span v-else>-</span>
    </template>
    <template slot-scope="scope" slot="condition-slot">
      <div v-if="scope.row.dynamicApplyFlag === 'Y'">
        <div v-if="scope.row.staticApplyFlag === 'Y'" class="round-box-info-text red">고정 + 동적</div>
        <div v-else class="round-box-info-text blue">
          동적
        </div>
      </div>
      {{scope.row.eventCondition}}
    </template>
  </el-table-wrapper>
  <w-update-event-alarm-rule-popup :sliding-popup-type="isSettingPopup ? 'setting' : null" ref="updateEventAlarmRulePopup" :isOnlyPredictRscList="isOnlyPredictRscList"
    :target-event-alarm-data="updateRow" :individual="true" :has-auth="hasAuth" @reload="loadRuleData"></w-update-event-alarm-rule-popup>
</div>
</template>

<script>
import { differenceWith, cloneDeep, isNil, isEqual, isEmpty } from 'lodash';
import { MANAGETYPE_KEY, COMMON_KEY } from '@/constants/managetype-key';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import { booleanDefine } from '@/utils/boolean';
import RscAPI from '@/api/model/rsc';
import FileApi from '@/api/common/file';
import { getManagetypeKeyByObjtypeId, getManagetypeKeyByObjDefineId } from '@/utils/managetype-key';
import RuleSettingsAPI from '@/api/settings/common/rule-settings';
import EventAlarmRuleSettingsAPI from '@/api/settings/common/event-alarm-rule-settings';
import WUpdateEventAlarmRulePopup from '@/views/settings/operation/BasicInfoSettings/EventAlarmRuleSettings/popup/UpdateEventAlarmRulePopup';
import WEventlevelCell from '@/components/table/EventlevelCell';

const ALL_KEY = 'ALL';
const ruleColumns = [
  {
    type: 'selection',
    width: 42,
  },
  {
    prop: 'individualFlag',
    label: '개별설정',
    headerAlign: 'center',
    align: 'center',
    scopedSlot: 'individual-slot',
    width: 60,
    filters: [
      {
        text: '개별',
        value: booleanDefine.TRUE_Y,
      },
      {
        text: '정책',
        value: booleanDefine.TRUE_N,
      },
    ],
  },
  {
    prop: 'rsctypeName',
    label: '자원구분명',
    headerAlign: 'center',
    width: 150,
    searchable: true,
  },
  {
    prop: 'rscName',
    label: '자원명',
    headerAlign: 'center',
    width: 150,
    searchable: true,
  },
  {
    prop: 'eventJudgePriority',
    label: '판단순위',
    headerAlign: 'center',
    width: 70,
  },
  {
    prop: 'valueName',
    label: '자원구분키',
    headerAlign: 'center',
    minWidth: 90,
    searchable: true,
  },
  {
    prop: 'eventMessage',
    label: '이벤트 메시지',
    headerAlign: 'center',
    // minWidth: 200,
    searchable: true,
  },
  {
    prop: 'eventlevelName',
    remoteProp: 'eventlevelId',
    label: '이벤트 등급',
    headerAlign: 'center',
    width: 90,
    scopedSlot: 'eventlevel-slot',
    searchType: 'eventlevel',
    searchable: true,
  },
  {
    prop: 'eventCondition',
    label: '이벤트 판단 조건',
    scopedSlot: 'condition-slot',
    headerAlign: 'center',
    minWidth: 200,
    searchable: true,
  },
  {
    label: '알람 방식',
    headerAlign: 'center',
    childColumns: [
      {
        prop: 'smsFlag',
        label: '문자',
        headerAlign: 'center',
        scopedSlot: 'sms-slot',
        width: 70,
        searchable: false,
      },
      {
        prop: 'emailFlag',
        label: '이메일',
        headerAlign: 'center',
        scopedSlot: 'email-slot',
        width: 70,
        searchable: false,
      },
    ],
  },
  {
    prop: 'alarmRepeatName',
    label: '알람 순차전송 템플릿',
    headerAlign: 'center',
    width: 140,
    searchable: true,
  },
];

export default {
  name: 'WObjEventAlarmSetTable',
  components: {
    WUpdateEventAlarmRulePopup,
    WEventlevelCell,
  },
  props: {
    /**
     * 관리 대상 정보
     */
    obj: {
      type: Object,
    },
    /**
     * 컴포넌트 사용 위치가 환경 설정 팝업인지 여부
     */
    isSettingPopup: {
      type: Boolean,
      default: false,
    },
    /**
     * 제어 스크립트 설정 제공 여부
     */
    showScriptSet: {
      type: Boolean,
      default: false,
    },
    /**
     * 테이블 높이.
     */
    tableHeight: {
      type: String,
    },
    /**
     * 예측 대상 자원으로 선택된 항목만 보일것인지 여부
     */
    isOnlyPredictRscList: {
      type: Boolean,
      default: false,
    },
    /**
     * 사용자 계정 알람 설정 플래그 - 사용자는 알람관련만 설정할 수 있도록 분기
     */
    hasAuth: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      /* 관리 구분, 자원 정보 */
      managetypeId: null,
      managetypeKeyList: [],
      managetypeKey: null,
      rsctypeList: [],
      rsctypeId: null,
      rscList: [],
      rscId: null,
      rsctypeRscKey: null, // rsctypeId.rscId 조합
      agentList: [],
      agentObjId: null,
      /* 파라미터 */
      managetypeParams: null,
      rscParams: null,
      ruleParams: null,
      /* 이벤트/알람 테이블 */
      columnDefault,
      showSearchTool: false,
      ruleColumns,
      ruleLoading: false,
      ruleLoadingText: null,
      ruleTotal: 0,
      ruleChangeFlag: false, // 정책 변경 여부 (true: 변경 / false: 미변경)
      eventAlarmRuleTableData: [],
      eventAlarmRuleTableOriginData: [],
      checkedEventAlarmSettings: [], // 선택된(체크된) 이벤트/알람 설정 배열
      updateRow: null, // 수정할 이벤트/알람 설정
      selectedEventAlarmSetting: null, // 선택된 이벤트/알람 설정 데이터
    };
  },
  computed: {
    /**
     * 제어 스크립트 설정 컬럼 제공 여부
     * @author Ju
     * @return {boolean}
     */
    showScriptColumn() {
      return this.showScriptSet && (this.managetypeId === 'NMS' || this.managetypeId === 'SMS');
    },
    /**
     * 이벤트/알람 정책 테이블 컬럼
     * @author Ju
     * @return {Array}
     */
    eventAlarmRuleTableColumn() {
      // 관리자 계정의 경우만 '적용', '스크립트' 컬럼을 제공하도록 변경 (Song - 2020. 01. 29)
      const columns = cloneDeep(this.ruleColumns);
      if (this.hasAuth) {
        columns.splice(1, 0,
          {
            prop: 'applyFlag',
            label: '적용',
            headerAlign: 'center',
            width: 60,
            align: 'center',
            scopedSlot: 'apply-slot',
            filters: [
              {
                text: '적용',
                value: booleanDefine.TRUE_Y,
              },
              {
                text: '해제',
                value: booleanDefine.FALSE_N,
              },
            ],
          },
        );
        if (this.showScriptColumn && this.hasAuth) {
          columns.push({
            label: '스크립트',
            headerAlign: 'center',
            align: 'center',
            width: 70,
            scopedSlot: 'script-slot',
          });
          // return columns;
        }
        return columns;
      }
      return this.ruleColumns;
    },
    /**
     * 테이블 높이 스타일
     * @author Ju
     * @return {String}
     */
    tableHeightStyle() {
      return isNil(this.tableHeight) ? null : `height:${this.tableHeight}`;
    },
    /**
     * 테이블 높이에 맞게 테이블 body를 채워서 표현할 지 여부 (테이블 높이가 설정된 경우 채워서 표현)
     * @author Ju
     * @return {[type]} [description]
     */
    tableFitHeight() {
      return !isNil(this.tableHeight);
    },
    /**
     * 선택한 항목에 동적 이벤트가 하나라도 존재하면 정책으로 저장할 수 없음을 판단하기 위한 플래그
     * @author yelim
     */
    isDynamicEvent() {
      let containDynamicEvent = false;
      if (!isEmpty(this.checkedEventAlarmSettings)) {
        this.checkedEventAlarmSettings.forEach((item) => {
          if (item.dynamicApplyFlag === 'Y') {
            containDynamicEvent = true;
          }
        });
      }
      return containDynamicEvent;
    },
  },
  watch: {
    obj: {
      immediate: true,
      handler(value) {
        if (!isEmpty(value)) {
          this.reset(true);
          this.$nextTick(() => {
            if (this.managetypeId === value.objManagetypeId) {
              this.managetypeKey = this.getManagetypeKeyForManagetype(value);
            } else {
              this.managetypeId = value.objManagetypeId;
            }
            // e2e트랜잭션 서비스일 경우 에이전트 정보를 가져온다.
            if (this.managetypeId === 'E2E') {
              RuleSettingsAPI.getAgentByTransactionService({
                objId: value.objId,
              })
                .then((response) => {
                  if (response.data.success) {
                    this.agentList = response.data.data;
                    if (!isEmpty(response.data.data)) {
                      this.agentObjId = this.agentList[0].objId;
                    }
                  } else {
                    this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'E2E 에이전트 정보', false));
                  }
                })
                .catch((e) => {
                  this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'E2E 에이전트 정보', false));
                  throw new Error(e);
                });
            }
          });
        } else {
          this.reset();
        }
      },
    },
    managetypeId: {
      immediate: true,
      handler(value) {
        if (!isNil(value)) {
          this.managetypeKey = this.getManagetypeKeyForManagetype(value);
          this.managetypeParams = {
            managetypeId: value,
            managetypeKey: this.managetypeKey,
          };
        }
      },
    },
    managetypeKey: {
      immediate: true,
      handler(value) {
        if (!isNil(this.managetypeId)) {
          this.managetypeParams = {
            managetypeId: this.managetypeId,
            managetypeKey: value,
          };
          this.rsctypeId = null;
          this.rscId = null;
          this.$refs.eventAlarmRuleTable.clearFilter();
          this.loadRsctype();
        }
      },
    },
    rsctypeId: {
      immediate: true,
      handler(value) {
        if (!isNil(value)) {
          this.rscId = null;
          this.rsctypeRscKey = null;
          this.$refs.eventAlarmRuleTable.clearFilter();
          this.loadRsc();
        }
      },
    },
    rsctypeRscKey: {
      handler(value) {
        if (!isNil(value)) {
          this.$refs.eventAlarmRuleTable.clearFilter();
          const rscId = value.includes('.') ? value.split('.')[1] : value;
          this.rscParams = {
            rsctypeId: this.rsctypeId === ALL_KEY ? null : this.rsctypeId,
            rscId: rscId === ALL_KEY ? null : rscId,
          };
          if (rscId !== ALL_KEY && this.managetypeId === 'VMS') {
            this.rscParams.rsctypeId = this.rsctypeRscKey.split('.')[0];
          }
        }
      },
    },
    managetypeParams: {
      immediate: true,
      handler() {
        this.setRuleParams();
      },
    },
    rscParams: {
      immediate: true,
      handler() {
        this.setRuleParams();
      },
    },
    ruleParams: {
      immediate: true,
      handler(value) {
        if (!isNil(value)) {
          this.loadRuleData();
        }
      },
    },
    /**
     * E2E 에이전트 선택시 마다 재로드한다.
     * @param  {[type]} objId [description]
     * @return {[type]}       [description]
     * @author jda
     */
    agentObjId: {
      immediate: true,
      handler(value) {
        if (isNil(value) || isNil(this.ruleParams)) {
          return;
        }
        this.loadRuleData();
      },
    },
  },
  methods: {
    /**
     * 관리 구분과 선택한 장비에 맞는 관리 구분 키를 반환한다.
     * @author Ju
     * @param  {[type]} managetypeId [description]
     * @return {[type]}              [description]
     */
    getManagetypeKeyForManagetype(managetypeId) {
      let managetypeKey;
      if (managetypeId === 'NMS') {
        managetypeKey = getManagetypeKeyByObjDefineId(this.obj.objDefineId);
      } else if (managetypeId === 'FMS') {
        this.managetypeKeyList = MANAGETYPE_KEY[managetypeId];
        managetypeKey = this.managetypeKeyList[0].managetypeKey;
      } else if (managetypeId === 'DBMS') {
        managetypeKey = getManagetypeKeyByObjtypeId(this.obj.objtypeId);
      } else if (managetypeId === 'VMS') {
        managetypeKey = this.obj.objtypeId;
      } else {
        managetypeKey = COMMON_KEY;
      }
      return managetypeKey;
    },
    /**
     * 이벤트/알람 정책 파라미터를 설정한다.
     * @author Ju
     */
    setRuleParams() {
      if (!isNil(this.obj) && !isNil(this.managetypeParams) && !isNil(this.rscParams)) {
        this.ruleParams = {
          objId: this.obj.objId,
          ...this.managetypeParams,
          ...this.rscParams,
        };
      }
    },
    /**
     * 자원 구분 정보를 로드한다.
     * @author Ju
     */
    loadRsctype() {
      const params = {
        managetypeId: this.managetypeId,
        managetypeKey: this.managetypeId === 'VMS' ? COMMON_KEY : this.managetypeKey,
      };
      if (isEqual(this.managetypeId, 'FMS') && isEqual(this.managetypeKey, 'FS')) {
        params.rsctypeId = this.obj.objtypeId;
      }

      if (isEqual(this.managetypeId, 'DBMS') || this.managetypeId === 'VMS') {
        params.objtypeId = this.obj.objtypeId;
        params.managetypeKey = COMMON_KEY;
      }
      RscAPI.getRsctypeList(params)
        .then((response) => {
          if (response.data.success) {
            const result = isNil(response.data.data) ? [] : response.data.data;
            if (isEqual(this.managetypeId, 'FMS') && isEqual(this.managetypeKey, 'FS')) {
              this.rsctypeList = result;
              if (!isEmpty(result)) {
                this.rsctypeId = result[0].rsctypeId;
              }
            } else {
              result.unshift({
                rsctypeId: ALL_KEY,
                rsctypeName: '전체',
              });
              this.rsctypeList = result;
              this.rsctypeId = ALL_KEY;
            }
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 정보', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 정보', false));
          throw new Error(e);
        });
    },
    /**
     * 자원 정보를 로드한다.
     * @author Ju
     */
    loadRsc() {
      const params = {
        managetypeId: this.managetypeId,
        managetypeKey: this.managetypeId === 'VMS' ? COMMON_KEY : this.managetypeKey,
        rsctypeId: this.rsctypeId === ALL_KEY ? null : this.rsctypeId,
      };

      if (this.managetypeId === 'DBMS' || this.managetypeId === 'VMS') {
        params.objtypeId = this.obj.objtypeId;
      }

      RscAPI.getRscList(params)
        .then((response) => {
          if (response.data.success) {
            const result = isNil(response.data.data) ? [] : response.data.data;
            result.unshift({
              rsctypeId: this.rsctypeId,
              rscId: ALL_KEY,
              rscName: '전체',
            });
            this.rscList = result;
            this.rsctypeRscKey = `${this.rsctypeId}.${ALL_KEY}`;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 정보', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 정보', false));
          throw new Error(e);
        });
    },
    /**
     * [reset description]
     * @author Ju
     * @param  {Boolean} onlyParams 파라미터만 초기화할 지 여부 (true: 파라미터만 초기화 / false: 파라미터+데이터 초기화)
     */
    reset(onlyParams = false) {
      this.managetypeId = null;
      this.managetypeKey = null;
      this.rsctypeId = null;
      this.rscId = null;
      this.rsctypeRscKey = null;

      this.managetypeParams = null;
      this.rscParams = null;
      this.ruleParams = null;
      this.agentObjId = null;
      this.agentList = [];

      if (!onlyParams) {
        this.eventAlarmRuleTableData = [];
        this.eventAlarmRuleTableOriginData = [];

        this.checkedEventAlarmSettings = [];
        this.selectedEventAlarmSetting = null;
        this.updateRow = null;

        this.ruleLoading = false;
        this.showSearchTool = false;

        if (this.$refs.eventAlarmRuleTable) {
          this.$refs.eventAlarmRuleTable.clearFilter();
        } else {
          this.$nextTick(() => {
            this.$refs.eventAlarmRuleTable.clearFilter();
          });
        }
      }
    },
    /**
     * 이벤트/알람 정보를 조회한다.
     * @author Ju
     */
    loadRuleData() {
      if (this.$refs.eventAlarmRuleTable) {
        this.loadRuleTableData();
      } else {
        this.$nextTick(() => {
          this.loadRuleTableData();
        });
      }
    },
    /**
     * 이벤트/알람 정보를 조회한다.
     * @author Ju
     */
    loadRuleTableData() {
      if ((this.managetypeId === 'E2E' && isNil(this.agentObjId)) || (this.managetypeKey === 'FS' && isNil(this.rsctypeId))) {
        return;
      }
      const params = this.getRuleTableParams();
      params.isOnlyPredictRscList = this.isOnlyPredictRscList;

      // TODO Ju 이벤트 판단 조건 수정 시 이전 이벤트 판단 조건 일부 텍스트 잔제가 남는 현상 해결을 위해 임시로 빈 데이터 적용 후 결과 값 바인딩하도록 처리. 관련하여 정확한 원인과 해결책을 찾을 경우 해당 화면과 비슷하게 임시로 처리한 화면 일괄 수정 필요
      this.eventAlarmRuleTableOriginData = [];
      this.eventAlarmRuleTableData = [];

      this.ruleLoadingText = null;
      this.ruleLoading = true;
      if (this.obj.objManagetypeId === 'E2E') {
        params.rsctypeKey = this.obj.rsctypeKey;
      }
      EventAlarmRuleSettingsAPI.getEventAlarmRuleList(params)
        .then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            if (isNil(result)) {
              this.eventAlarmRuleTableOriginData = [];
              this.eventAlarmRuleTableData = [];
              if (this.showScriptColumn) {
                this.showEventAlarmScriptSetting(null);
              }
            } else {
              this.eventAlarmRuleTableData = result;
              this.eventAlarmRuleTableOriginData = cloneDeep(result);
              if (this.showScriptColumn) {
                this.showEventAlarmScriptSetting(result[0]);
              }
            }
            this.ruleTotal = response.data.total;
            this.ruleChangeFlag = false;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트/알람 설정', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트/알람 설정', false));
          throw new Error(e);
        })
        .finally(() => {
          this.ruleLoading = false;
        });
    },
    /**
     * 이벤트/알람 정책 테이블 정보 조회를 위한 파라미터 객체를 반환한다.
     * @author Ju
     * @return {Object}
     */
    getRuleTableParams() {
      const tableParams = this.$refs.eventAlarmRuleTable.getParameter();
      const params = {
        ...this.ruleParams,
        ...tableParams,
      };

      if (this.managetypeId === 'E2E') {
        params.objId = this.agentObjId;
      }
      return params;
    },
    /**
     * 이벤트/알람 정책 정보를 수정한다.
     * @author Ju
     * @param  {Object} row 수정할 이벤트/알람 정책 정보
     */
    editEventAlarmSettingData(row) {
      this.updateRow = cloneDeep(row);
      this.$refs.updateEventAlarmRulePopup.$refs.slidingPopup.visible = true;
    },
    /**
     * 이벤트/알람 정책 수정 내용을 저장한다.
     * @author Ju
     */
    saveEventAlarmSettingChanges() {
      const target = '이벤트/알람 설정';
      const action = msgUtil.action.SAVE;
      EventAlarmRuleSettingsAPI.updateIndividualEventAlarmRuleList(differenceWith(this.eventAlarmRuleTableData, this.eventAlarmRuleTableOriginData, isEqual))
        .then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadRuleData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
          throw new Error(e);
        });
    },
    /**
     * 이벤트/알람 정책 수정 내용을 이전 내용으로 되돌린다.
     * @author Ju
     */
    rejectEventAlarmSettingChanges() {
      this.loadRuleData();
    },
    /**
     * 이벤트/알람 정책 변경 여부를 확인한다.
     * @author Ju
     */
    checkEventAlarmRuleChanges() {
      this.ruleChangeFlag = !isEqual(this.eventAlarmRuleTableData, this.eventAlarmRuleTableOriginData);
    },
    /**
     * 테이블 헤더 검색 도구 제공 여부를 설정한다.
     * @author Ju
     */
    toggleShowSearchTool() {
      this.showSearchTool = !this.showSearchTool;
    },
    /**
     * 이벤트/알람 설정 테이블 선택한 row 변경 이베트 핸들러
     * @author Ju
     * @param  {Array} selection 선택된 row 배열
     */
    onSelectionChange(selection) {
      this.checkedEventAlarmSettings = selection;
    },
    /**
     * 장비별 이벤트/알람 설정을 정책 설정으로 저장한다.
     * @author Ju
     */
    saveObjEventAlarmSettingsToRule() {
      const target = '이벤트/알람 설정';
      const action = '정책으로 저장';
      EventAlarmRuleSettingsAPI.applyIndividualEventAlarmRuleList(this.checkedEventAlarmSettings)
        .then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadRuleData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
          throw new Error(e);
        });
    },
    /**
     * 장비별 이벤트/알람 설정을 삭제하여 정책 설정으로 복원한다.
     * @author Ju
     */
    deleteObjEventAlarmSettings() {
      this.$confirm(...msgUtil.getCustomConfirmData('정책 설정 값으로 복원하시겠습니까?')).then(() => {
        const target = '이벤트/알람 설정';
        const action = '정책 설정 값으로 복원';
        EventAlarmRuleSettingsAPI.deleteIndividualEventAlarmRuleList(this.checkedEventAlarmSettings)
          .then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.loadRuleData();
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          })
          .catch((e) => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
            throw new Error(e);
          });
      });
    },
    /**
     * 이벤트/알람 설정을 선택한다.
     * @author Ju
     * @param  {Object} row 선택한 이벤트/알람 설정
     */
    showEventAlarmScriptSetting(row) {
      this.selectedEventAlarmSetting = cloneDeep(row);
      this.$emit('show-control-script', this.selectedEventAlarmSetting);
    },
    /**
     * 이벤트/알람 설정 적용 여부를 변경한다.
     * @author Ju
     */
    changeApplyFlag() {
      this.checkEventAlarmRuleChanges();
    },
    /**
     * 이벤트/알람 설정 정보를 엑셀 파일로 출력한다.
     * @author Ju
     */
    exportExcel() {
      const params = this.getRuleTableParams();
      delete params.start;
      delete params.limit;

      this.ruleLoadingText = '엑셀 출력 중..';
      this.ruleLoading = true;
      params.isOnlyPredictRscList = this.isOnlyPredictRscList;
      EventAlarmRuleSettingsAPI.createRuleEventAlarmExcel(params)
        .then((response) => {
          if (response.data.success && !isNil(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          } else {
            this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
        })
        .finally(() => {
          this.ruleLoading = false;
          this.ruleLoadingText = null;
        });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/EventAlarmRuleSettings/components/ObjEventAlarmSetTable.vue